module.exports = __webpack_public_path__ + "static/media/watch.a2a37257.svg";